






















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Dropdown extends Vue {
  @Prop() data!: any[];
  @Prop({ default: false }) changeModel!: boolean; // true if we want to fire off changeSelectedModel event

  public updateItem(item: any) {
    const data = item.model ? item.model : item;
    this.$emit(`update:model`, data);
    if (this.changeModel) {
      this.$emit("changeSelectedModel", item);
    }
  }
}
